const Footer = () => {
  return (
    <footer className="mb-16 md:mb-0 my bg-gray-900 text-white w-full ">
      <p className="md:text-xl text-center md:py-10 py-2 ">
        Designed and developed By{" "}
        <a
          className="font-bold"
          href="https://www.github.com/haddercone"
          target="_blank"
        >
          Robin Singh
        </a>
      </p>
    </footer>
  );
};

export default Footer;
